import { Box } from "@mui/material";
import { useThemeContext } from "../../../globalContext/global-context";
import type { CompletionLayout } from "../../CompletionControl";

export const FormsCompactCompletionLayout: CompletionLayout = ({
  message,
  actions,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box
      data-testid="session-control-complete"
      sx={{ padding: `${theme.tokens.spacing["4"]}px`, textAlign: "center" }}
    >
      {message}
      <Box sx={{ marginTop: `${theme.tokens.spacing["4"]}px` }}>{actions}</Box>
    </Box>
  );
};

export const FormsWideCompletionLayout: CompletionLayout = ({
  message,
  actions,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box
      data-testid="session-control-complete"
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        paddingBottom: `${theme.tokens.spacing["5"]}px`,
      }}
    >
      <Box
        sx={{
          width: "min(100%, 440px)",
          minHeight: 340,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: `${theme.tokens.spacing["2"]}px`,
          padding: `${theme.tokens.spacing["4"]}px`,
          textAlign: "center",
          backgroundColor: theme.tokens.color.surface.card,
          border: `1px solid ${theme.tokens.color.text.primary}`,
          borderRadius: `${theme.tokens.shape.radius.lg}px`,
          boxShadow: theme.tokens.elevation["2"],
        }}
      >
        {message}
      </Box>
      <Box sx={{ position: "absolute", right: 0, bottom: 0 }}>{actions}</Box>
    </Box>
  );
};
